import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from "@angular/router";
import { DevoteeService } from './../devotee.service'
import { SharedService } from "./../../shared/shared.service";

@Component({
  selector: 'devotee-login',
  templateUrl: './devotee-login.component.html',
  styleUrls: ['./devotee-login.component.css']
})
export class DevoteeLoginComponent implements OnInit {

  constructor(private router: Router,
    private devoteeService: DevoteeService,
    private sharedService: SharedService) { }
  
    errorMsg: string = "";
    successMsg: string = "";
    isOTPSend: boolean = false;
    timerMinute: any;
    timerSecond: any;

  ngOnInit() {
    this.isOTPSend = false;

    let tokenData = this.sharedService.getTokenDataAtLocStorage();

    if (tokenData)
      this.getDevoteeProfileData();
  }

  
  sendOTP(mobileNo: string) {
    this.errorMsg = '';
    if (!mobileNo) {
      this.errorMsg = "Please enter mobile no";
      return;
    }

    this.sharedService.showSpinner();
    this.devoteeService.sendOTP(mobileNo).subscribe(
      data => {
        if (!data) {
          this.errorMsg = "There is some error while sending opt, please try after some time.";
          return;
        }
        this.isOTPSend = true;
        this.successMsg = "OTP send"
        this.startOTPTimer(120);
        this.sharedService.hideSpinner()

      },
      err => {
        console.log(err);
        this.errorMsg = err;
        this.sharedService.hideSpinner()
      },
      () => this.sharedService.hideSpinner()
    )
  }


  verifyOTP(mobileNo: string, otp: string) {
    this.errorMsg = '';
    if (!mobileNo) {
      this.errorMsg = "Please enter mobile no";
      return;
    }

    this.sharedService.showSpinner();
    this.devoteeService.varifyOTP(mobileNo, otp).subscribe(
      data => {
        if (!data) {
          this.errorMsg = "There is some error while sending opt, please try after some time.";
          return;
        }

        this.sharedService.setTokenDataAtLocStorage(data.Token);
        this.getDevoteeProfileData();
      },
      err => {
        console.log(err);
        this.errorMsg = err;
        this.sharedService.hideSpinner()
      },
      () => this.sharedService.hideSpinner()
    )
  }

  getDevoteeProfileData() {
    this.errorMsg = '';
    this.sharedService.showSpinner();
    this.devoteeService.getUserProfile().subscribe(
      devoteeData => {
        if (!devoteeData) {
          this.errorMsg = "Some thing went wrong, please try again";
          return;
        }
        this.sharedService.setDevoteeDataAtLocStorage(devoteeData)

        console.log("LoginSuccess");
        if (devoteeData.FirstName == null || devoteeData.LastName == null
          || devoteeData.FirstName.trim() + devoteeData.LastName.trim() === '')
          this.router.navigate(["/devoteeprofile"]);
        else
          this.router.navigate(["/dasarafestival"]);
      },
      err => {
        console.log(err);
        this.sharedService.removeTokenDataAtLocStorage();
        this.sharedService.removeDevoteeDataAtLocStorage();
      },
      () => this.sharedService.hideSpinner()
    )
  }


  // devoteeLogin(mobileNo: string): void {
  //   if (!mobileNo) {
  //     this.errorMsg = "Please enter mobile no";
  //     return;
  //   }

  //   this.sharedService.showSpinner();
  //   this.devoteeService.getByLogin(mobileNo).subscribe(
  //     data => {
  //       if (!data) {
  //         this.errorMsg = "Mobile number is not registered";
  //         return;
  //       }
  //       this.sharedService.setDevoteeDataAtLocStorage(data)

  //       console.log("LoginSuccess");
  //       if (data.IsVarified)
  //         this.router.navigate(["/dasarafestival"]);
  //       else
  //         this.router.navigate(["/dasarafestival"]);        
  //     },
  //     err => console.log(err),
  //     () => this.sharedService.hideSpinner()
  //   )
  // }

  startOTPTimer(duration: number) {
    let timer = duration;
    const interval = setInterval(() => {
      this.timerMinute = Math.floor(timer / 60);
      this.timerSecond = timer % 60;

      this.timerMinute = this.timerMinute < 10 ? '0' + this.timerMinute : this.timerMinute;
      this.timerSecond = this.timerSecond < 10 ? '0' + this.timerSecond : this.timerSecond;

      console.log(`Time Remaining: ${this.timerMinute}:${this.timerSecond}`);

      if (--timer < 0) {
        clearInterval(interval);
        this.isOTPSend = false;
        console.log("OTP expired");
      }
    }, 1000);
  }
}



// WEBPACK FOOTER //
// ./src/app/devotee/devotee-login/devotee-login.component.ts